import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { R } from '@core/utils/r';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';

export class TMChangeOrderPreviewPageBloc extends BaseBloc {
  private readonly tmChangeOrderBloc = resolve(Blocs.tmChangeOrder);

  constructor(private readonly id: string) {
    super();
  }
  readonly loading = new LoadingState();

  item$ = this.tmChangeOrderBloc.selectOrder(this.id);

  onInit() {
    return this.tmChangeOrderBloc.fetchChangeOrder(this.id).pipe(this.loading.run());
  }

  onSigned = this.tmChangeOrderBloc.onSigned;
}
